export default __webpack_public_path__ + "static/media/krishna.d0f96d34.jpg";